import Swiper, { EffectFade, Autoplay } from 'swiper';
import '../../../../node_modules/swiper/modules/effect-fade/effect-fade.scss';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { playPauseVideo, resetVideoControls } from '../helpers/video';

Swiper.use([EffectFade, Autoplay]);

export const hero = () => {
	gsap.registerPlugin(ScrollToPlugin);

	const heroSliderModules = document.querySelectorAll('.m__hero-swiper');
	if ( heroSliderModules ) {
		heroSliderModules.forEach((heroSlider) => {
			const heroSliderSlides = heroSlider.querySelectorAll('.m__hero-swiper-slide');
			const slideVideos = heroSlider.querySelectorAll('.js__hero-swiper-video');
			const videoControlElemContainer = heroSlider.querySelector('.m__hero__video-controls');
			const videoControlElem = videoControlElemContainer.querySelector('.js-video-controls');
			
			// Trigger the first video on page load
			if (slideVideos.length > 0) {
				for (var source in slideVideos[0].children) {
					var videoSource = slideVideos[0].children[source];
					if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
						videoSource.src = videoSource.dataset.src;
					}
				}
				slideVideos[0].load();
				slideVideos[0].play();
			}

			if ( heroSliderSlides.length === 1 ) {
				if (slideVideos.length > 0) {
					playPauseVideo(slideVideos[0], videoControlElem);
				}
			}

			if (heroSliderSlides.length > 1) {
				// Initialise the slider
				const hSwiper = new Swiper(heroSlider, {
					centeredSlides: true,
					slidesPerView: 1,
					loop: true,
					effect: "fade",
					speed: 1500,
					fadeEffect: {
						crossFade: true
					},
					autoplay: {
						delay: 3000,
						disableOnInteraction: true,
					},
					keyboard: {
						enabled: true,
						onlyInViewport: true,
					},
				});

				hSwiper.on('beforeSlideChangeStart', function () {
					// Check for any videos on the slide and make sure they're lazy-loaded
					let slideVideo = hSwiper.slides[hSwiper.activeIndex].querySelector("video");

					if (slideVideo) {
						slideVideo.pause();
						
						resetVideoControls(videoControlElem);
					}
				});

				hSwiper.on('slideChange', function () {
					// Check for any videos on the slide and make sure they're lazy-loaded
					let slideVideo = hSwiper.slides[hSwiper.activeIndex].querySelector("video");

					if (slideVideo) {
						videoControlElemContainer.classList.remove('hidden');

						if (!slideVideo.currentTime > 0) { // Only reload video if it isn't already playing
							for (var source in slideVideo.children) {
								var videoSource = slideVideo.children[source];
								if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
									videoSource.src = videoSource.dataset.src;
								}
							}

							slideVideo.load();
							slideVideoTimeout = setTimeout(() => {
								slideVideo.play();
							}, 1000);

							playPauseVideo(slideVideo, videoControlElem);
						}
					} else {
						videoControlElemContainer.classList.add('hidden');
					}
				});

				const heroModule = heroSlider.closest('.m__hero');
				const heroContentSlider = heroModule.querySelector('.m__hero__content-swiper');
				
				// Initialise the slider
				if ( heroContentSlider) {					
					const heroContentSliderSlides = heroContentSlider.querySelectorAll('.m__hero__content-swiper-slide');

					if ( heroContentSliderSlides.length > 1) {						
						const heroContentSwiper = new Swiper(heroContentSlider, {
							slidesPerView: 1,
							loop: true,
							effect: "fade",
							speed: 1500,
							fadeEffect: {
								crossFade: true
							},
							autoplay: false,
							keyboard: false,
							allowTouchMove: false,
						});
		
						hSwiper.on('slidePrevTransitionStart', function (swiper) {
							heroContentSwiper.slidePrev(1500, true);
						});
						hSwiper.on('slideNextTransitionStart', function (swiper) {
							heroContentSwiper.slideNext(1500, true);
						});
					}
				}
			}

			// Scroll down trigger
			const heroExploreButton = heroSlider.closest('.m__hero').querySelector('.js__hero__explore');

			if (heroExploreButton) {
				heroExploreButton.addEventListener('click', (event) => {
					event.preventDefault();

					//Assumes hero is the first module on the page, so scrolls to the 2nd module
					const scrollToElem = document.querySelector('#scroll-2');
					const offset = document.querySelector('.header').offsetHeight;

					gsap.to(window, {
						duration: 0.5, 
						scrollTo: {
							y: scrollToElem, 
							offsetY: offset 
						}
					});
				});
			}
		});
	}
}
